function persist(obj) {
  Object.keys(obj).forEach((key) => {
    sessionStorage.setItem(key, obj[key]);
  });
}

function clear(...keys) {
  keys.forEach((key) => {
    sessionStorage.removeItem(key);
  });
}

function get(...keys) {
  if (keys.length === 1) {
    return sessionStorage.getItem(keys[0]);
  }

  return keys.map((key) => sessionStorage.getItem(key));
}

export default {
  clear,
  persist,
  get,
};
